import "../../../../design/communityVideos.css";
import Footer from "../Footer";

export default function CommunityVideos() {
    const instructions = [
        {
            src: 'https://www.youtube.com/embed/JJSzk0kk76M',
            title: 'რეგისტრაცია',
            tag: 'ინსტრუქცია'
        },
        {
            src: 'https://www.youtube.com/embed/X-G5qoRojYM',
            title: 'ავტორიზაცია',
            tag: 'ინსტრუქცია'
        },
    ];

    const videoHistories = [
        {
            src: '',
            title: '',
            tag: ''
        }
    ];

    return (
        <div className="communityVideos-wrapper">
            <section className="communityVideos-section">

                {/* Main Header */}
                <div className="communityVideos-premium-header">
                    <h1 className="communityVideos-main-title">ვიდეო გალერეა</h1>
                    <div className="communityVideos-title-underline"></div>
                </div>

                {/* Section 1: Instructions */}
                <div className="communityVideos-container">
                    <div className="communityVideos-section-header">
                        <span className="communityVideos-badge communityVideos-badge-blue">სწავლება</span>
                        <h2 className="communityVideos-title">ინსტრუქციები</h2>
                    </div>

                    <div className="communityVideos-grid">
                        {instructions.map((item, index) => (
                            <div key={index} className="communityVideos-card">
                                <div className="communityVideos-iframe-wrapper">
                                    <iframe
                                        src={item.src}
                                        title={item.title}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                                <div className="communityVideos-card-content">
                                    <span className="communityVideos-card-tag">{item.tag}</span>
                                    <h3 className="communityVideos-card-title">{item.title}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Section 2: Podcasts */}
                <div className="communityVideos-container communityVideos-secondary-section">
                    <div className="communityVideos-section-header">
                        <span className="communityVideos-badge communityVideos-badge-purple">გამოცდილება</span>
                        <h2 className="communityVideos-title">პოდკასტები და ისტორიები</h2>
                    </div>

                    <p className="communityVideos-intro">
                        გაეცანით ჩვენი საზოგადოების წევრების რეალურ გამოცდილებას.
                        აღმოაჩინეთ, როგორ ცვლის ჩვენი პლატფორმა სწავლების პროცესს.
                    </p>

                    <div className="communityVideos-grid">
                        {videoHistories.map((item, index) => (
                            <div key={index} className="communityVideos-card">
                                <div className="communityVideos-iframe-wrapper">
                                    <iframe
                                        src={item.src}
                                        title={item.title}
                                        allowFullScreen
                                    ></iframe>
                                </div>
                                <div className="communityVideos-card-content">
                                    <span className="communityVideos-card-tag communityVideos-tag-purple">{item.tag}</span>
                                    <h3 className="communityVideos-card-title">{item.title}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}